interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const ArrowLeftNewLayout = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill={color} className={className}>
        <path d="M1.23106 8L8.84197 15.1352C9.04343 15.3241 9.05363 15.6405 8.86477 15.842C8.6759 16.0434 8.35948 16.0536 8.15803 15.8648L0.158028 8.36477C-0.0526781 8.16723 -0.0526781 7.83277 0.158028 7.63523L8.15803 0.135233C8.35948 -0.0536321 8.6759 -0.0434251 8.86477 0.158031C9.05363 0.359487 9.04343 0.675905 8.84197 0.86477L1.23106 8Z" fill={color} />
      </svg>
    </>
  );
}

export default ArrowLeftNewLayout;